import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VList,{attrs:{"subheader":""}},[_c(VSubheader,[_vm._v("LiveEvents Config")]),_c(VListItem,[_c('span',{staticClass:"font-italic"},[_vm._v("No config needed...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }